import React from 'react';
import cx from 'classnames';

export interface PanelLeftIconProps {
  size?: string;
  className?: string;
  title?: string;
}

export const PanelLeftIconComponent = (props: PanelLeftIconProps): JSX.Element => {
  const { size = '1x1o2', className = '', title = 'panel-left' } = props;

  const iconClasses = cx(
    'o-els-icon-svg',
    `o-els-icon-svg--${size}`,
    className
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={48}
      height={48}
      className={iconClasses}
      aria-hidden="true"
    >
      {title && <title>{title}</title>}
      <path d="M13.84 21.38a1.5 1.5 0 1 1-.01 3h-2.7a1.5 1.5 0 0 1 0-3zM13.84 15.08a1.5 1.5 0 1 1-.01 3l-2.7-.02a1.5 1.5 0 0 1 0-3z" />
      <path
        fillRule="evenodd"
        d={
          'M40.4 8.02A4 4 0 0 1 44 12v24a4 4 0 0 1-3.6 3.98L40 40H8a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h32z' +
          'M8 11a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h9.73V11z' +
          'm12.73 26H40a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1H20.73z'
        }
        clipRule="evenodd"
      />
    </svg>
  );
};

const PanelLeftIcon = PanelLeftIconComponent;
export default PanelLeftIcon;
